import { render, staticRenderFns } from "./another-person-info.vue?vue&type=template&id=b4f302be&scoped=true&lang=pug&"
import script from "./another-person-info.vue?vue&type=script&lang=js&"
export * from "./another-person-info.vue?vue&type=script&lang=js&"
import style0 from "./another-person-info.vue?vue&type=style&index=0&id=b4f302be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f302be",
  null
  
)

export default component.exports